import { c as _c } from "react/compiler-runtime";
import { useDesignSteps } from './hooks/use-design-steps';

/**
 * The design, recapped at the top of a printed sheet.
 *
 * On screen the steps bar says the same thing, but as links. On paper the
 * reader still needs the four settings the sheet was computed from — and
 * nothing to click.
 */
export const DesignPrintSummary = () => {
  const $ = _c(4);
  const steps = useDesignSteps();
  let t0;
  if ($[0] !== steps) {
    t0 = steps.filter(_temp).map(_temp2);
    $[0] = steps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="ptl-print-only flex flex-wrap gap-2">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(step) {
  return step.kind === "parameter";
}
function _temp2(step_0) {
  return <div key={step_0.id} className="flex flex-[1_1_140px] flex-col gap-1 rounded-md border border-border px-3 py-2.5"><span className="ptl-label">{step_0.name}</span><span className="font-mono text-[12.5px]">{step_0.value}</span></div>;
}